// usePagination.js
import { useRouter, useRoute } from 'vue-router';

export function usePagination(list, filter, extraQuery = null) {
  const router = useRouter();
  const route = useRoute();

  const getExtraQuery = () => {
    if (typeof extraQuery === 'function') {
      return extraQuery() || {};
    }
    return extraQuery || {};
  };

  const setUrl = () => {
    const page = list.getPage;
    const query = {
      ...route.query,
      ...getExtraQuery(),
      page,
    };

    if (filter) {
      query.af = filter.value || undefined;
    }

    router.push({
      path: route.path,
      query,
    });
  };

  const changePage = (val) => {
    list.page(val);
    setUrl();
  };

  return {
    setUrl,
    changePage,
  };
}
